import { useUser } from '@clerk/nextjs';
import { trpc } from '@web-app/utils/trpc';

/**
 * The patient's Bridge case. `viewerId` keeps an Infinity staleTime cache
 * from surviving a same-tab Clerk user switch. The server ignores it.
 *
 * `refetchOnMount: 'always'` belongs on the visit panel only. That panel
 * lists prior authorizations and prescriptions that can appear after a
 * webhook, and this query would otherwise stay cached. Status, follow-up,
 * and session prep share the query and should not refetch on every mount.
 */
export function useMedicareBridgeCase(
  patientHealthieId: string | null | undefined,
  options?: { refetchOnMount?: boolean | 'always' },
) {
  const { user, isLoaded } = useUser();
  const id = patientHealthieId ?? '';

  return trpc.medicareBridge.getCase.useQuery(
    { patientHealthieId: id, viewerId: user?.id ?? '' },
    {
      enabled: Boolean(isLoaded && id),
      retry: false,
      ...(options?.refetchOnMount
        ? { refetchOnMount: options.refetchOnMount }
        : {}),
    },
  );
}
